export enum EDocPacketUrls {
  TENANT = 'tenant',
  HP_DOCUMENT_PACKET = 'hp-doc-packet',
  HP_CONTACT = 'hp-contact',
  NAME = 'name',
  PHONE = 'phone',
  EMAIL = 'email',
  FAX_NUMBER = 'fax-number',
  HP_VISITATION = 'hp-visitation',
  HP_LETTER = 'hp-letter',
  HP_FORM = 'hp-form',
  TEMPLATES = 'templates',
}
